import { isVisible } from "./isVisible";

/**
 * Get all focusable elements from provided container
 * @param {HTMLElement} [container = document] - Container where we should check focusable elements
 * @returns {HTMLElement[]} Focusable elements
 */

export function getFocusableElements(container = document) {
  const focusable = [
    ...container.querySelectorAll(
      "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]"
    ),
  ];

  return focusable.filter((element) => isVisible(element));
}
